import { bus_xe, BusXeItemResponse } from "../../../models/response/bus/bus_xe";

export enum eBusXeActionTypeIds {
	LOAD_START = "BUS_XE_LOAD_START",
	LOAD_SUCCESS = "BUS_XE_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_XE_LOAD_ERROR",

	SHOW_DETAIL = "BUS_XE_SHOW_DETAIL",
	CLOSE_DETAIL = "BUS_XE_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "BUS_XE_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "BUS_XE_SHOW_CONFIRM",
	CLOSE_CONFIRM = "BUS_XE_CLOSE_CONFIRM",

	DELETE_START = "BUS_XE_DELETE_START",
	DELETE_SUCCESS = "BUS_XE_DELETE_SUCCESS",
	DELETE_ERROR = "BUS_XE_DELETE_ERROR",

	SAVE_START = "BUS_XE_SAVE_START",
	SAVE_SUCCESS = "BUS_XE_SAVE_SUCCESS",
	SAVE_ERROR = "BUS_XE_SAVE_ERROR"
}

export interface IBusXeLoadStart {
	type: eBusXeActionTypeIds.LOAD_START,
	payload: number
}
export interface IBusXeLoadSuccess {
	type: eBusXeActionTypeIds.LOAD_SUCCESS,
	payload: BusXeItemResponse[]
}
export interface IBusXeLoadErr {
	type: eBusXeActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusXeShowDetail {
	type: eBusXeActionTypeIds.SHOW_DETAIL,
	payload?: BusXeItemResponse
}
export interface IBusXeCloseDetail {
	type: eBusXeActionTypeIds.CLOSE_DETAIL
}
export interface IBusXeChangeSelectedIds {
	type: eBusXeActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IBusXeShowConfirm {
	type: eBusXeActionTypeIds.SHOW_CONFIRM,
	payload?: BusXeItemResponse
}
export interface IBusXeCloseConfirm {
	type: eBusXeActionTypeIds.CLOSE_CONFIRM
}
export interface IBusXeDeleteStart {
	type: eBusXeActionTypeIds.DELETE_START,
	payload: number
}
export interface IBusXeDeleteSuccess {
	type: eBusXeActionTypeIds.DELETE_SUCCESS
}
export interface IBusXeDeleteErr {
	type: eBusXeActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IBusXeSaveStart {
	type: eBusXeActionTypeIds.SAVE_START,
	payload: bus_xe
}
export interface IBusXeSaveSuccess {
	type: eBusXeActionTypeIds.SAVE_SUCCESS
}
export interface IBusXeSaveErr {
	type: eBusXeActionTypeIds.SAVE_ERROR,
	payload: string
}

export type IBusXeActionTypes = IBusXeLoadStart | IBusXeLoadSuccess | IBusXeLoadErr |
	IBusXeShowDetail | IBusXeCloseDetail |
	IBusXeChangeSelectedIds |
	IBusXeShowConfirm | IBusXeCloseConfirm |
	IBusXeDeleteStart | IBusXeDeleteSuccess | IBusXeDeleteErr |
	IBusXeSaveStart | IBusXeSaveSuccess | IBusXeSaveErr
